<template>
  <div>
    <ul
      class="
        process-page-breadcrumb
        mb-3
        p-0
        mt-0
        mx-0
        list-unstyled
        flex-column
        sm:flex-row
        flex-wrap
        align-items-stretch
        sm:align-items-center
        gap-2
        sm:gap-0
      "
    >
      <li class="w-full mb-2 sm:mb-0 sm:w-auto sm:mr-3 flex-shrink-0">
        <Button
          label="Voltar"
          class="p-button-sm w-full sm:w-auto"
          icon="pi pi-angle-double-left"
          @click="goBack"
        />
      </li>
      <li class="flex flex-wrap align-items-center min-w-0 flex-1 gap-2">
        <router-link
          :to="{ name: 'processes' }"
          class="process-page-breadcrumb__link white-space-nowrap flex-shrink-0"
          >{{ $t("processes") }}</router-link
        >
        <span class="px-0 sm:px-2 flex-shrink-0">
          <i class="pi pi-angle-right text-500 line-height-3" />
        </span>
        <span
          v-if="process.processTypeName"
          class="
            process-page-breadcrumb__current
            text-900
            line-height-3
            min-w-0
          "
          :title="crumbTitle"
        >
          {{ process.code }} {{ process.processTypeName }} -
          {{ process.client && process.client.name ? process.client.name : "" }}
          <template v-if="process.client2 && process.client2.id">
            | {{ process.client2.name }}
          </template>
        </span>
      </li>
    </ul>
    <ProgressBar v-if="isLoading" mode="indeterminate" class="mb-4" />
    <h1
      v-if="process.processTypeName"
      class="process-page-title md:pb-3 md:pt-3 md:mb-3 md:mt-0 pb-0 mb-2"
      :title="`${process.code} ${process.processTypeName}`"
    >
      {{ process.code }} {{ process.processTypeName }}
    </h1>
    <ProcessPosts :process-id="id" :process="process" @changed="getProcess" />
  </div>
</template>

<script>
import ProcessPosts from "./ProcessPosts.vue";

export default {
  components: { ProcessPosts },
  props: { id: { type: [String, Number], default: null } },
  data() {
    return {
      process: {},
      isLoading: false,
    };
  },
  computed: {
    crumbTitle() {
      if (!this.process.processTypeName) return "";
      let t =
        this.process.code +
        " " +
        this.process.processTypeName +
        " - " +
        (this.process.client && this.process.client.name
          ? this.process.client.name
          : "");
      if (this.process.client2 && this.process.client2.id) {
        t += " | " + this.process.client2.name;
      }
      return t;
    },
  },
  watch: {
    id() {
      this.getProcess();
    },
  },
  created() {
    window.scrollTo(0, 0);
    this.getProcess();
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    getProcess() {
      this.process = {};
      this.isLoading = true;
      this.$root
        .apiGet(this.$root.getApiProcesses(this.id))
        .then((response) => {
          this.isLoading = false;
          this.process = response.data.data;
          if (this.process.opportunityId) {
            this.getOpportunityFiles();
          }
        })
        .catch((error) => {
          this.isLoading = false;
          this.$root.toastError(error.response.data.msg_code);
          if (
            error.response.data.msg_code === "unauthorized" ||
            error.response.data.msg_code === "process_not_found"
          ) {
            this.$router.push({ name: "processes" });
          }
        });
    },
    getOpportunityFiles() {
      this.$root
        .apiGet(
          this.$root.getApiFileManagerOpportunity(this.process.opportunityId),
          { params: { dataType: "processFiles" } }
        )
        .then((response) => {
          this.process.opportunityFiles = response.data.data;
          const groups = response.data.data || {};
          const firstGroupKey = Object.keys(groups)[0];
          const firstGroupFiles = firstGroupKey ? groups[firstGroupKey] : [];
          const processFiles = Array.isArray(this.process.files)
            ? this.process.files
            : [];
          this.process.files = processFiles.concat(
            Array.isArray(firstGroupFiles) ? firstGroupFiles : []
          );
        })
        .catch((error) => {
          this.$root.toastError(error.response.data.msg_code);
        });
    },
  },
};
</script>

<style scoped>
/* Breadcrumb oculto em mobile; a partir de sm mantém flex */
.process-page-breadcrumb li:not(:first-child) {
  display: none !important;
}

@media screen and (min-width: 576px) {
  .process-page-breadcrumb {
    display: flex;
  }
  .process-page-breadcrumb li:not(:first-child) {
    display: flex !important;
  }
}

.process-page-breadcrumb__link {
  font-size: 0.875rem;
}

@media screen and (min-width: 576px) {
  .process-page-breadcrumb__link {
    font-size: 1rem;
  }
}

.process-page-breadcrumb__current {
  font-size: 0.8125rem;
  line-height: 1.35;
  word-break: break-word;
  flex: 1 1 100%;
}

@media screen and (min-width: 576px) {
  .process-page-breadcrumb__current {
    font-size: 1rem;
    line-height: 1.5;
    flex: 1 1 auto;
  }
}

/* Título principal mais compacto em telemóvel */
.process-page-title {
  font-size: 1.125rem;
  font-weight: 600;
  line-height: 1.3;
  word-break: break-word;
}

@media screen and (min-width: 768px) {
  .process-page-title {
    font-size: 1.5rem;
    line-height: 1.35;
  }
}

@media screen and (min-width: 992px) {
  .process-page-title {
    font-size: 1.75rem;
  }
}
</style>
